export default __webpack_public_path__ + "static/media/eye_icon.271547a3.svg";